<script setup>
import { Head } from '@inertiajs/vue3'
import {
  Wrench, ListChecks, History, Images, MessageCircle,
  FileText, Calendar, User, MapPin, Activity,
} from 'lucide-vue-next'
import PageHeader from '../Components/PageHeader.vue'
import Card from '../Components/Card.vue'
import CtaButton from '../Components/CtaButton.vue'
import ProgressBar from '../Components/ProgressBar.vue'
import MaintenanceTimeline from '../Components/MaintenanceTimeline.vue'
import TaskList from '../Components/TaskList.vue'
import HistoryFeed from '../Components/HistoryFeed.vue'
import ServicePhotos from '../Components/ServicePhotos.vue'

const props = defineProps({
  aircraft: { type: Object, required: true },
  summary: { type: Object, required: true },
  progress: { type: Number, required: true },
  steps: { type: Array, required: true },
  tasks: { type: Array, required: true },
  history: { type: Array, required: true },
  photos: { type: Array, required: true },
})

const facts = [
  { label: 'Status',              value: props.summary.status,            icon: Activity },
  { label: 'Ordem de serviço',    value: props.summary.service_order,     icon: FileText },
  { label: 'Aberta em',           value: props.summary.opened_at,         icon: Calendar },
  { label: 'Previsão de entrega', value: props.summary.delivery_forecast, icon: Calendar },
  { label: 'Responsável técnico', value: props.summary.technician,        icon: User },
  { label: 'Local',               value: props.summary.hangar,            icon: MapPin },
]
</script>

<template>
  <Head title="Manutenção" />

  <div class="space-y-6">
    <PageHeader title="MANUTENÇÃO" :aircraft="aircraft" />

    <!-- Coluna principal + coluna lateral de contexto -->
    <div class="grid grid-cols-1 gap-6 xl:grid-cols-3">
      <div class="space-y-6 xl:col-span-2">
        <Card title="Andamento" :icon="Wrench">
          <ProgressBar :value="progress" />
          <div class="mt-6 border-t border-slate-100 pt-6">
            <MaintenanceTimeline :steps="steps" />
          </div>
        </Card>

        <Card title="Tarefas" :icon="ListChecks">
          <TaskList :tasks="tasks" />
        </Card>

        <Card title="Histórico" :icon="History">
          <HistoryFeed :entries="history" />
        </Card>
      </div>

      <div class="space-y-6">
        <Card title="Resumo" :icon="FileText">
          <dl class="divide-y divide-slate-100">
            <div v-for="fact in facts" :key="fact.label" class="flex items-start gap-3 py-3">
              <component :is="fact.icon" class="mt-0.5 h-4 w-4 shrink-0 text-slate-400" aria-hidden="true" />
              <dt class="text-sm text-slate-500">{{ fact.label }}</dt>
              <dd class="ml-auto text-right text-sm font-semibold text-up-navy">{{ fact.value }}</dd>
            </div>
          </dl>
        </Card>

        <Card title="Fotos do serviço" :icon="Images" link-label="Ver todas" link-href="/documentos">
          <ServicePhotos :photos="photos" />
        </Card>

        <Card>
          <p class="text-sm leading-relaxed text-slate-600">
            Dúvidas sobre alguma etapa? A equipe técnica responde em até 1 dia útil.
          </p>
          <div class="pt-4">
            <CtaButton href="/suporte?assunto=manutencao" :icon="MessageCircle">Falar com a equipe</CtaButton>
          </div>
        </Card>
      </div>
    </div>
  </div>
</template>
